import { render, staticRenderFns } from "./EditPandiCheckup.vue?vue&type=template&id=00c1c336&scoped=true&"
import script from "./EditPandiCheckup.vue?vue&type=script&lang=js&"
export * from "./EditPandiCheckup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c1c336",
  null
  
)

export default component.exports